<!--
 * @Description: 业务参数下拉组件
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-05-22 14:08:00
 * @LastEditors: cxh
-->
<template>
  <CosSelect
    allow-clear
    v-bind="$attrs"
    :autoLanguage="false"
    v-model:value="modelValue"
    style="width: 100%"
    :placeholder="placeholder"
    :options="pageOption"
    show-search
    :show-arrow="true"
    :filter-option="filterOption"
    :fieldNames="fieldNamesComputed"
    :max-tag-count="pageMaxTagCount"
  >
    <slot></slot>
  </CosSelect>
</template>
<script lang="ts" setup>
import { computed, onMounted, nextTick, watch, ref } from 'vue'
import type { PropType } from 'vue'
import { useVModel } from '@vueuse/core'
import { listByParamCodes } from '@/api/common'
import { ParamCodeParams } from '@/typings/common'
import { useInteractionStore } from '@/stores/interaction'
const props = defineProps({
  value: {
    type: [String, Number, Array]
  },
  label: {
    type: [String, Array]
  },
  record: {
    type: Object
  },
  placeholder: {
    type: String
  },
  paramCode: {
    type: String // 只接受单个
  },
  options: {
    type: Array,
    default: () => {
      return []
    }
  },
  appId: {
    type: String as PropType<ParamCodeParams['appId']>,
    default: 'cos_fbu'
  },
  maxTagCount: {
    type: [Number, String]
  },
  setInitValue: {
    type: Boolean, // 是否设置默认值
    default: false
  },
  fieldNames: Object
})
const optionPage = ref([])
const emit = defineEmits(['update:value', 'update:label', 'update:record'])
const modelValue = useVModel(props, 'value', emit)

const shareInfo = useInteractionStore()
const eumns = {
  'en-US': 'enName',
  'zh-CN': 'cnName'
}
const pageMaxTagCount = computed(() => {
  if (props.maxTagCount) {
    return props.maxTagCount
  }
  return 'responsive'
})
const fieldNamesComputed = computed(() => {
  // 中英文
  if (props.fieldNames) {
    return props.fieldNames
  }
  return { label: eumns[shareInfo.language] || 'name', value: 'id' }
})
const pageOption = computed(() => {
  let result: any[] = props.options
  if (props.paramCode) {
    result = optionPage.value
  }
  return result && Array.isArray(result) ? result : []
})
const fetch = () => {
  if (props.paramCode) {
    listByParamCodes({
      appId: props.appId,
      paramCodes: [props.paramCode]
    }).then((res) => {
      optionPage.value = props.paramCode && res.data?.[props.paramCode]
    })
  }
}
const filterOption = (input: string, option: any) => {
  let txt = option[eumns[shareInfo.language]]
  if (typeof txt === 'number') {
    txt = txt?.toString()
  }
  return txt?.toLowerCase().indexOf(input.toLowerCase()) >= 0
}
onMounted(() => {
  fetch()
})
const findLabeRecord = (val: any) => {
  if (val && pageOption.value && pageOption.value.length) {
    // 如果modelValue.value 是数组
    if (Array.isArray(val)) {
      const labelAry: any = []
      const recordAry: any = []
      val.forEach((v) => {
        const find: any = pageOption.value.find((item: any) => item.id === v)
        labelAry.push(find?.name)
        recordAry.push(find)
      })
      emit('update:label', labelAry)
      emit('update:record', recordAry)
      return
    }
    const find: any = pageOption.value.find((item: any) => item.id === val)
    emit('update:label', find?.name)
    emit('update:record', find)
  } else {
    emit('update:label')
    emit('update:record')
  }
}
watch(
  () => [modelValue.value, pageOption.value],
  () => {
    findLabeRecord(modelValue.value)
  },
  {
    immediate: true
  }
)
</script>
